/* tslint:disable */
/* eslint-disable */
/**
 * Default API
 * All endpoints not defined under specific APIs
 *
 * OpenAPI spec version: Latest
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { AssessmentAssessmentPeriodsResponse } from '../models';
import { AssessmentAssessmentsResponse } from '../models';
import { AssessmentBenchmarkLevel } from '../models';
import { AssessmentClassesResponse } from '../models';
import { AssessmentCreateCommand } from '../models';
import { AssessmentCreateResponse } from '../models';
import { AssessmentDashboardResponse } from '../models';
import { AssessmentEditLlarsCommand } from '../models';
import { AssessmentEditLlarsResponse } from '../models';
import { AssessmentEditLlassCommand } from '../models';
import { AssessmentEditLlassResponse } from '../models';
import { AssessmentExportListCommand } from '../models';
import { AssessmentExportListResponse } from '../models';
import { AssessmentImportCommand } from '../models';
import { AssessmentImportListResponse } from '../models';
import { AssessmentMoveCommand } from '../models';
import { AssessmentMoveListResponse } from '../models';
import { AssessmentResourceListResponse } from '../models';
import { AssessmentStudentNavigationListResponse } from '../models';
import { AssessmentStudentSearchResponse } from '../models';
import { AssessmentStudentStageMasteryCommand } from '../models';
import { AssessmentStudentStageMasteryResponse } from '../models';
import { AssessmentStudentsResponse } from '../models';
import { AssessmentSubType } from '../models';
import { AssessmentSummaryGraphemePhonemeQuerySortOrderType } from '../models';
import { AssessmentSummaryGraphemePhonemeQuerySortTypeFilter } from '../models';
import { AssessmentSummaryGraphemePhonemeResponse } from '../models';
import { AssessmentSummaryListResponse } from '../models';
import { AssessmentSummaryOverviewQuerySortOrderType } from '../models';
import { AssessmentSummaryOverviewQuerySortTypeFilter } from '../models';
import { AssessmentSummaryOverviewResponse } from '../models';
import { AssessmentSummaryProgressQuerySortOrderType } from '../models';
import { AssessmentSummaryProgressQuerySortTypeFilter } from '../models';
import { AssessmentSummaryProgressResponse } from '../models';
import { AssessmentSummaryReadingQuerySortOrderType } from '../models';
import { AssessmentSummaryReadingQuerySortTypeFilter } from '../models';
import { AssessmentSummaryReadingResponse } from '../models';
import { AssessmentSummarySpellingQuerySortOrderType } from '../models';
import { AssessmentSummarySpellingQuerySortTypeFilter } from '../models';
import { AssessmentSummarySpellingResponse } from '../models';
import { AssessmentSummaryStageOverviewQuerySortOrderType } from '../models';
import { AssessmentSummaryStageOverviewQuerySortTypeFilter } from '../models';
import { AssessmentSummaryStageOverviewResponse } from '../models';
import { AssessmentType } from '../models';
import { AssessmentValidateMoveCommand } from '../models';
import { AssessmentValidateMoveResponse } from '../models';
import { SharedModelsCommandResponse } from '../models';
/**
 * AssessmentApi - axios parameter creator
 * @export
 */
export const AssessmentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Provides a list of assessment periods
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentAssessmentPeriodsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Assessment/AssessmentPeriods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Provides a list of available assessments
         * @param {string} [studentId] 
         * @param {AssessmentType} [assessmentType] Assessment type.
         * @param {string} [assessmentPeriodId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentAssessmentsGet: async (studentId?: string, assessmentType?: AssessmentType, assessmentPeriodId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Assessment/Assessments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (studentId !== undefined) {
                localVarQueryParameter['StudentId'] = studentId;
            }

            if (assessmentType !== undefined) {
                localVarQueryParameter['AssessmentType'] = assessmentType;
            }

            if (assessmentPeriodId !== undefined) {
                localVarQueryParameter['AssessmentPeriodId'] = assessmentPeriodId;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Provides a list of classes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentClassesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Assessment/Classes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates an initial assessment record
         * @param {AssessmentCreateCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentCreatePost: async (body?: AssessmentCreateCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Assessment/Create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Provides an overview of student's benchmarks
         * @param {string} [_class] 
         * @param {string} [assessmentPeriodId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentDashboardGet: async (_class?: string, assessmentPeriodId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Assessment/Dashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (_class !== undefined) {
                localVarQueryParameter['Class'] = _class;
            }

            if (assessmentPeriodId !== undefined) {
                localVarQueryParameter['AssessmentPeriodId'] = assessmentPeriodId;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Provides a detailed Llars assessment
         * @param {string} [recordId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentEditLlarsGet: async (recordId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Assessment/EditLlars`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (recordId !== undefined) {
                localVarQueryParameter['RecordId'] = recordId;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Edits a Llars assessment
         * @param {AssessmentEditLlarsCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentEditLlarsPost: async (body?: AssessmentEditLlarsCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Assessment/EditLlars`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Provides a detailed Llass assessment
         * @param {string} [recordId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentEditLlassGet: async (recordId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Assessment/EditLlass`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (recordId !== undefined) {
                localVarQueryParameter['RecordId'] = recordId;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Edits a Llass assessment
         * @param {AssessmentEditLlassCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentEditLlassPost: async (body?: AssessmentEditLlassCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Assessment/EditLlass`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Downloads an excel export of student results
         * @param {AssessmentExportListCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentExportListPost: async (body?: AssessmentExportListCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Assessment/ExportList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Provides a list of classes and info for importing historical data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentImportListGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Assessment/ImportList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Imports historical data for a list of students
         * @param {AssessmentImportCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentImportPost: async (body?: AssessmentImportCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Assessment/Import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Provides a list of data for moving assessment records
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentMoveListGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Assessment/MoveList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Moves assessment records to a different assessment period
         * @param {AssessmentMoveCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentMovePost: async (body?: AssessmentMoveCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Assessment/Move`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Provides a list of assessment resources to download
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentResourceListGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Assessment/ResourceList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Provides a list of students and their assessment record ids. Used for navigating between students while conducting assessments
         * @param {string} [studentId] 
         * @param {string} [classId] 
         * @param {string} [assessmentId] 
         * @param {string} [assessmentPeriodId] 
         * @param {AssessmentSubType} [assessmentType] Assessment sub type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentStudentNavigationListGet: async (studentId?: string, classId?: string, assessmentId?: string, assessmentPeriodId?: string, assessmentType?: AssessmentSubType, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Assessment/StudentNavigationList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (studentId !== undefined) {
                localVarQueryParameter['StudentId'] = studentId;
            }

            if (classId !== undefined) {
                localVarQueryParameter['ClassId'] = classId;
            }

            if (assessmentId !== undefined) {
                localVarQueryParameter['AssessmentId'] = assessmentId;
            }

            if (assessmentPeriodId !== undefined) {
                localVarQueryParameter['AssessmentPeriodId'] = assessmentPeriodId;
            }

            if (assessmentType !== undefined) {
                localVarQueryParameter['AssessmentType'] = assessmentType;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Provides a list of students for the provided class id or search term
         * @param {string} [classId] 
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentStudentSearchGet: async (classId?: string, searchTerm?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Assessment/StudentSearch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (classId !== undefined) {
                localVarQueryParameter['ClassId'] = classId;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['SearchTerm'] = searchTerm;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Provides a list of student stage mastery for an assessment period
         * @param {AssessmentStudentStageMasteryCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentStudentStageMasteryPost: async (body?: AssessmentStudentStageMasteryCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Assessment/StudentStageMastery`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Provides a list of students for a certain class
         * @param {string} [classId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentStudentsGet: async (classId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Assessment/Students`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (classId !== undefined) {
                localVarQueryParameter['ClassId'] = classId;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Provides an overview of student's assessment results for LLARS Subtest One - Grapheme-phoneme Knowledge
         * @param {string} [_class] 
         * @param {string} [assessmentPeriodId] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {AssessmentSummaryGraphemePhonemeQuerySortTypeFilter} [sortType] 
         * @param {AssessmentSummaryGraphemePhonemeQuerySortOrderType} [sortOrder] 
         * @param {string} [sortLetter] 
         * @param {string} [sortStageId] 
         * @param {AssessmentBenchmarkLevel} [benchmark] Assessment benchmark level.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentSummaryGraphemePhonemeGet: async (_class?: string, assessmentPeriodId?: string, pageNumber?: number, pageSize?: number, sortType?: AssessmentSummaryGraphemePhonemeQuerySortTypeFilter, sortOrder?: AssessmentSummaryGraphemePhonemeQuerySortOrderType, sortLetter?: string, sortStageId?: string, benchmark?: AssessmentBenchmarkLevel, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Assessment/SummaryGraphemePhoneme`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (_class !== undefined) {
                localVarQueryParameter['Class'] = _class;
            }

            if (assessmentPeriodId !== undefined) {
                localVarQueryParameter['AssessmentPeriodId'] = assessmentPeriodId;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['PageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (sortType !== undefined) {
                localVarQueryParameter['SortType'] = sortType;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['SortOrder'] = sortOrder;
            }

            if (sortLetter !== undefined) {
                localVarQueryParameter['SortLetter'] = sortLetter;
            }

            if (sortStageId !== undefined) {
                localVarQueryParameter['SortStageId'] = sortStageId;
            }

            if (benchmark !== undefined) {
                localVarQueryParameter['Benchmark'] = benchmark;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Provides a list of filters used on the Student Results page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentSummaryListGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Assessment/SummaryList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Provides an overview of student's assessment results
         * @param {string} [_class] 
         * @param {string} [assessmentPeriodId] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {AssessmentSummaryOverviewQuerySortTypeFilter} [sortType] 
         * @param {AssessmentSummaryOverviewQuerySortOrderType} [sortOrder] 
         * @param {string} [sortStageId] 
         * @param {AssessmentBenchmarkLevel} [benchmark] Assessment benchmark level.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentSummaryOverviewGet: async (_class?: string, assessmentPeriodId?: string, pageNumber?: number, pageSize?: number, sortType?: AssessmentSummaryOverviewQuerySortTypeFilter, sortOrder?: AssessmentSummaryOverviewQuerySortOrderType, sortStageId?: string, benchmark?: AssessmentBenchmarkLevel, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Assessment/SummaryOverview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (_class !== undefined) {
                localVarQueryParameter['Class'] = _class;
            }

            if (assessmentPeriodId !== undefined) {
                localVarQueryParameter['AssessmentPeriodId'] = assessmentPeriodId;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['PageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (sortType !== undefined) {
                localVarQueryParameter['SortType'] = sortType;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['SortOrder'] = sortOrder;
            }

            if (sortStageId !== undefined) {
                localVarQueryParameter['SortStageId'] = sortStageId;
            }

            if (benchmark !== undefined) {
                localVarQueryParameter['Benchmark'] = benchmark;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Provides an overview of student's assessment progress across assessment periods
         * @param {string} [_class] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {AssessmentSummaryProgressQuerySortTypeFilter} [sortType] 
         * @param {AssessmentSummaryProgressQuerySortOrderType} [sortOrder] 
         * @param {string} [sortAssessmentPeriodId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentSummaryProgressGet: async (_class?: string, pageNumber?: number, pageSize?: number, sortType?: AssessmentSummaryProgressQuerySortTypeFilter, sortOrder?: AssessmentSummaryProgressQuerySortOrderType, sortAssessmentPeriodId?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Assessment/SummaryProgress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (_class !== undefined) {
                localVarQueryParameter['Class'] = _class;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['PageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (sortType !== undefined) {
                localVarQueryParameter['SortType'] = sortType;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['SortOrder'] = sortOrder;
            }

            if (sortAssessmentPeriodId !== undefined) {
                localVarQueryParameter['SortAssessmentPeriodId'] = sortAssessmentPeriodId;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Provides an overview of student's assessment results for LLARS Subtest Two - Reading non-words
         * @param {string} [_class] 
         * @param {string} [assessmentPeriodId] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {AssessmentSummaryReadingQuerySortTypeFilter} [sortType] 
         * @param {AssessmentSummaryReadingQuerySortOrderType} [sortOrder] 
         * @param {string} [sortText] 
         * @param {string} [sortStageId] 
         * @param {AssessmentBenchmarkLevel} [benchmark] Assessment benchmark level.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentSummaryReadingGet: async (_class?: string, assessmentPeriodId?: string, pageNumber?: number, pageSize?: number, sortType?: AssessmentSummaryReadingQuerySortTypeFilter, sortOrder?: AssessmentSummaryReadingQuerySortOrderType, sortText?: string, sortStageId?: string, benchmark?: AssessmentBenchmarkLevel, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Assessment/SummaryReading`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (_class !== undefined) {
                localVarQueryParameter['Class'] = _class;
            }

            if (assessmentPeriodId !== undefined) {
                localVarQueryParameter['AssessmentPeriodId'] = assessmentPeriodId;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['PageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (sortType !== undefined) {
                localVarQueryParameter['SortType'] = sortType;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['SortOrder'] = sortOrder;
            }

            if (sortText !== undefined) {
                localVarQueryParameter['SortText'] = sortText;
            }

            if (sortStageId !== undefined) {
                localVarQueryParameter['SortStageId'] = sortStageId;
            }

            if (benchmark !== undefined) {
                localVarQueryParameter['Benchmark'] = benchmark;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Provides an overview of student's assessment results for LLARS Subtest Three - Spelling
         * @param {string} [_class] 
         * @param {string} [assessmentPeriodId] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {AssessmentSummarySpellingQuerySortTypeFilter} [sortType] 
         * @param {AssessmentSummarySpellingQuerySortOrderType} [sortOrder] 
         * @param {string} [sortLetter] 
         * @param {string} [sortStageId] 
         * @param {AssessmentBenchmarkLevel} [benchmark] Assessment benchmark level.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentSummarySpellingGet: async (_class?: string, assessmentPeriodId?: string, pageNumber?: number, pageSize?: number, sortType?: AssessmentSummarySpellingQuerySortTypeFilter, sortOrder?: AssessmentSummarySpellingQuerySortOrderType, sortLetter?: string, sortStageId?: string, benchmark?: AssessmentBenchmarkLevel, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Assessment/SummarySpelling`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (_class !== undefined) {
                localVarQueryParameter['Class'] = _class;
            }

            if (assessmentPeriodId !== undefined) {
                localVarQueryParameter['AssessmentPeriodId'] = assessmentPeriodId;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['PageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (sortType !== undefined) {
                localVarQueryParameter['SortType'] = sortType;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['SortOrder'] = sortOrder;
            }

            if (sortLetter !== undefined) {
                localVarQueryParameter['SortLetter'] = sortLetter;
            }

            if (sortStageId !== undefined) {
                localVarQueryParameter['SortStageId'] = sortStageId;
            }

            if (benchmark !== undefined) {
                localVarQueryParameter['Benchmark'] = benchmark;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Provides an overview of student's assessment results by stage
         * @param {string} [_class] 
         * @param {string} [assessmentPeriodId] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {AssessmentSummaryStageOverviewQuerySortTypeFilter} [sortType] 
         * @param {AssessmentSummaryStageOverviewQuerySortOrderType} [sortOrder] 
         * @param {AssessmentBenchmarkLevel} [benchmark] Assessment benchmark level.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentSummaryStageOverviewGet: async (_class?: string, assessmentPeriodId?: string, pageNumber?: number, pageSize?: number, sortType?: AssessmentSummaryStageOverviewQuerySortTypeFilter, sortOrder?: AssessmentSummaryStageOverviewQuerySortOrderType, benchmark?: AssessmentBenchmarkLevel, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Assessment/SummaryStageOverview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (_class !== undefined) {
                localVarQueryParameter['Class'] = _class;
            }

            if (assessmentPeriodId !== undefined) {
                localVarQueryParameter['AssessmentPeriodId'] = assessmentPeriodId;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['PageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (sortType !== undefined) {
                localVarQueryParameter['SortType'] = sortType;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['SortOrder'] = sortOrder;
            }

            if (benchmark !== undefined) {
                localVarQueryParameter['Benchmark'] = benchmark;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Validates data for moving assessment records
         * @param {AssessmentValidateMoveCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentValidateMovePost: async (body?: AssessmentValidateMoveCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Assessment/ValidateMove`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AssessmentApi - functional programming interface
 * @export
 */
export const AssessmentApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Provides a list of assessment periods
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAssessmentAssessmentPeriodsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentAssessmentPeriodsResponse>> {
            const localVarAxiosArgs = await AssessmentApiAxiosParamCreator(configuration).apiAssessmentAssessmentPeriodsGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Provides a list of available assessments
         * @param {string} [studentId] 
         * @param {AssessmentType} [assessmentType] Assessment type.
         * @param {string} [assessmentPeriodId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAssessmentAssessmentsGet(studentId?: string, assessmentType?: AssessmentType, assessmentPeriodId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentAssessmentsResponse>> {
            const localVarAxiosArgs = await AssessmentApiAxiosParamCreator(configuration).apiAssessmentAssessmentsGet(studentId, assessmentType, assessmentPeriodId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Provides a list of classes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAssessmentClassesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentClassesResponse>> {
            const localVarAxiosArgs = await AssessmentApiAxiosParamCreator(configuration).apiAssessmentClassesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Creates an initial assessment record
         * @param {AssessmentCreateCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAssessmentCreatePost(body?: AssessmentCreateCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentCreateResponse>> {
            const localVarAxiosArgs = await AssessmentApiAxiosParamCreator(configuration).apiAssessmentCreatePost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Provides an overview of student's benchmarks
         * @param {string} [_class] 
         * @param {string} [assessmentPeriodId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAssessmentDashboardGet(_class?: string, assessmentPeriodId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentDashboardResponse>> {
            const localVarAxiosArgs = await AssessmentApiAxiosParamCreator(configuration).apiAssessmentDashboardGet(_class, assessmentPeriodId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Provides a detailed Llars assessment
         * @param {string} [recordId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAssessmentEditLlarsGet(recordId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentEditLlarsResponse>> {
            const localVarAxiosArgs = await AssessmentApiAxiosParamCreator(configuration).apiAssessmentEditLlarsGet(recordId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Edits a Llars assessment
         * @param {AssessmentEditLlarsCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAssessmentEditLlarsPost(body?: AssessmentEditLlarsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SharedModelsCommandResponse>> {
            const localVarAxiosArgs = await AssessmentApiAxiosParamCreator(configuration).apiAssessmentEditLlarsPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Provides a detailed Llass assessment
         * @param {string} [recordId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAssessmentEditLlassGet(recordId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentEditLlassResponse>> {
            const localVarAxiosArgs = await AssessmentApiAxiosParamCreator(configuration).apiAssessmentEditLlassGet(recordId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Edits a Llass assessment
         * @param {AssessmentEditLlassCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAssessmentEditLlassPost(body?: AssessmentEditLlassCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SharedModelsCommandResponse>> {
            const localVarAxiosArgs = await AssessmentApiAxiosParamCreator(configuration).apiAssessmentEditLlassPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Downloads an excel export of student results
         * @param {AssessmentExportListCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAssessmentExportListPost(body?: AssessmentExportListCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentExportListResponse>> {
            const localVarAxiosArgs = await AssessmentApiAxiosParamCreator(configuration).apiAssessmentExportListPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Provides a list of classes and info for importing historical data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAssessmentImportListGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentImportListResponse>> {
            const localVarAxiosArgs = await AssessmentApiAxiosParamCreator(configuration).apiAssessmentImportListGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Imports historical data for a list of students
         * @param {AssessmentImportCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAssessmentImportPost(body?: AssessmentImportCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SharedModelsCommandResponse>> {
            const localVarAxiosArgs = await AssessmentApiAxiosParamCreator(configuration).apiAssessmentImportPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Provides a list of data for moving assessment records
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAssessmentMoveListGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentMoveListResponse>> {
            const localVarAxiosArgs = await AssessmentApiAxiosParamCreator(configuration).apiAssessmentMoveListGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Moves assessment records to a different assessment period
         * @param {AssessmentMoveCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAssessmentMovePost(body?: AssessmentMoveCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SharedModelsCommandResponse>> {
            const localVarAxiosArgs = await AssessmentApiAxiosParamCreator(configuration).apiAssessmentMovePost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Provides a list of assessment resources to download
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAssessmentResourceListGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentResourceListResponse>> {
            const localVarAxiosArgs = await AssessmentApiAxiosParamCreator(configuration).apiAssessmentResourceListGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Provides a list of students and their assessment record ids. Used for navigating between students while conducting assessments
         * @param {string} [studentId] 
         * @param {string} [classId] 
         * @param {string} [assessmentId] 
         * @param {string} [assessmentPeriodId] 
         * @param {AssessmentSubType} [assessmentType] Assessment sub type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAssessmentStudentNavigationListGet(studentId?: string, classId?: string, assessmentId?: string, assessmentPeriodId?: string, assessmentType?: AssessmentSubType, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentStudentNavigationListResponse>> {
            const localVarAxiosArgs = await AssessmentApiAxiosParamCreator(configuration).apiAssessmentStudentNavigationListGet(studentId, classId, assessmentId, assessmentPeriodId, assessmentType, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Provides a list of students for the provided class id or search term
         * @param {string} [classId] 
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAssessmentStudentSearchGet(classId?: string, searchTerm?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentStudentSearchResponse>> {
            const localVarAxiosArgs = await AssessmentApiAxiosParamCreator(configuration).apiAssessmentStudentSearchGet(classId, searchTerm, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Provides a list of student stage mastery for an assessment period
         * @param {AssessmentStudentStageMasteryCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAssessmentStudentStageMasteryPost(body?: AssessmentStudentStageMasteryCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentStudentStageMasteryResponse>> {
            const localVarAxiosArgs = await AssessmentApiAxiosParamCreator(configuration).apiAssessmentStudentStageMasteryPost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Provides a list of students for a certain class
         * @param {string} [classId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAssessmentStudentsGet(classId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentStudentsResponse>> {
            const localVarAxiosArgs = await AssessmentApiAxiosParamCreator(configuration).apiAssessmentStudentsGet(classId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Provides an overview of student's assessment results for LLARS Subtest One - Grapheme-phoneme Knowledge
         * @param {string} [_class] 
         * @param {string} [assessmentPeriodId] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {AssessmentSummaryGraphemePhonemeQuerySortTypeFilter} [sortType] 
         * @param {AssessmentSummaryGraphemePhonemeQuerySortOrderType} [sortOrder] 
         * @param {string} [sortLetter] 
         * @param {string} [sortStageId] 
         * @param {AssessmentBenchmarkLevel} [benchmark] Assessment benchmark level.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAssessmentSummaryGraphemePhonemeGet(_class?: string, assessmentPeriodId?: string, pageNumber?: number, pageSize?: number, sortType?: AssessmentSummaryGraphemePhonemeQuerySortTypeFilter, sortOrder?: AssessmentSummaryGraphemePhonemeQuerySortOrderType, sortLetter?: string, sortStageId?: string, benchmark?: AssessmentBenchmarkLevel, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentSummaryGraphemePhonemeResponse>> {
            const localVarAxiosArgs = await AssessmentApiAxiosParamCreator(configuration).apiAssessmentSummaryGraphemePhonemeGet(_class, assessmentPeriodId, pageNumber, pageSize, sortType, sortOrder, sortLetter, sortStageId, benchmark, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Provides a list of filters used on the Student Results page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAssessmentSummaryListGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentSummaryListResponse>> {
            const localVarAxiosArgs = await AssessmentApiAxiosParamCreator(configuration).apiAssessmentSummaryListGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Provides an overview of student's assessment results
         * @param {string} [_class] 
         * @param {string} [assessmentPeriodId] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {AssessmentSummaryOverviewQuerySortTypeFilter} [sortType] 
         * @param {AssessmentSummaryOverviewQuerySortOrderType} [sortOrder] 
         * @param {string} [sortStageId] 
         * @param {AssessmentBenchmarkLevel} [benchmark] Assessment benchmark level.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAssessmentSummaryOverviewGet(_class?: string, assessmentPeriodId?: string, pageNumber?: number, pageSize?: number, sortType?: AssessmentSummaryOverviewQuerySortTypeFilter, sortOrder?: AssessmentSummaryOverviewQuerySortOrderType, sortStageId?: string, benchmark?: AssessmentBenchmarkLevel, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentSummaryOverviewResponse>> {
            const localVarAxiosArgs = await AssessmentApiAxiosParamCreator(configuration).apiAssessmentSummaryOverviewGet(_class, assessmentPeriodId, pageNumber, pageSize, sortType, sortOrder, sortStageId, benchmark, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Provides an overview of student's assessment progress across assessment periods
         * @param {string} [_class] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {AssessmentSummaryProgressQuerySortTypeFilter} [sortType] 
         * @param {AssessmentSummaryProgressQuerySortOrderType} [sortOrder] 
         * @param {string} [sortAssessmentPeriodId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAssessmentSummaryProgressGet(_class?: string, pageNumber?: number, pageSize?: number, sortType?: AssessmentSummaryProgressQuerySortTypeFilter, sortOrder?: AssessmentSummaryProgressQuerySortOrderType, sortAssessmentPeriodId?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentSummaryProgressResponse>> {
            const localVarAxiosArgs = await AssessmentApiAxiosParamCreator(configuration).apiAssessmentSummaryProgressGet(_class, pageNumber, pageSize, sortType, sortOrder, sortAssessmentPeriodId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Provides an overview of student's assessment results for LLARS Subtest Two - Reading non-words
         * @param {string} [_class] 
         * @param {string} [assessmentPeriodId] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {AssessmentSummaryReadingQuerySortTypeFilter} [sortType] 
         * @param {AssessmentSummaryReadingQuerySortOrderType} [sortOrder] 
         * @param {string} [sortText] 
         * @param {string} [sortStageId] 
         * @param {AssessmentBenchmarkLevel} [benchmark] Assessment benchmark level.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAssessmentSummaryReadingGet(_class?: string, assessmentPeriodId?: string, pageNumber?: number, pageSize?: number, sortType?: AssessmentSummaryReadingQuerySortTypeFilter, sortOrder?: AssessmentSummaryReadingQuerySortOrderType, sortText?: string, sortStageId?: string, benchmark?: AssessmentBenchmarkLevel, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentSummaryReadingResponse>> {
            const localVarAxiosArgs = await AssessmentApiAxiosParamCreator(configuration).apiAssessmentSummaryReadingGet(_class, assessmentPeriodId, pageNumber, pageSize, sortType, sortOrder, sortText, sortStageId, benchmark, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Provides an overview of student's assessment results for LLARS Subtest Three - Spelling
         * @param {string} [_class] 
         * @param {string} [assessmentPeriodId] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {AssessmentSummarySpellingQuerySortTypeFilter} [sortType] 
         * @param {AssessmentSummarySpellingQuerySortOrderType} [sortOrder] 
         * @param {string} [sortLetter] 
         * @param {string} [sortStageId] 
         * @param {AssessmentBenchmarkLevel} [benchmark] Assessment benchmark level.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAssessmentSummarySpellingGet(_class?: string, assessmentPeriodId?: string, pageNumber?: number, pageSize?: number, sortType?: AssessmentSummarySpellingQuerySortTypeFilter, sortOrder?: AssessmentSummarySpellingQuerySortOrderType, sortLetter?: string, sortStageId?: string, benchmark?: AssessmentBenchmarkLevel, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentSummarySpellingResponse>> {
            const localVarAxiosArgs = await AssessmentApiAxiosParamCreator(configuration).apiAssessmentSummarySpellingGet(_class, assessmentPeriodId, pageNumber, pageSize, sortType, sortOrder, sortLetter, sortStageId, benchmark, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Provides an overview of student's assessment results by stage
         * @param {string} [_class] 
         * @param {string} [assessmentPeriodId] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {AssessmentSummaryStageOverviewQuerySortTypeFilter} [sortType] 
         * @param {AssessmentSummaryStageOverviewQuerySortOrderType} [sortOrder] 
         * @param {AssessmentBenchmarkLevel} [benchmark] Assessment benchmark level.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAssessmentSummaryStageOverviewGet(_class?: string, assessmentPeriodId?: string, pageNumber?: number, pageSize?: number, sortType?: AssessmentSummaryStageOverviewQuerySortTypeFilter, sortOrder?: AssessmentSummaryStageOverviewQuerySortOrderType, benchmark?: AssessmentBenchmarkLevel, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentSummaryStageOverviewResponse>> {
            const localVarAxiosArgs = await AssessmentApiAxiosParamCreator(configuration).apiAssessmentSummaryStageOverviewGet(_class, assessmentPeriodId, pageNumber, pageSize, sortType, sortOrder, benchmark, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Validates data for moving assessment records
         * @param {AssessmentValidateMoveCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAssessmentValidateMovePost(body?: AssessmentValidateMoveCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentValidateMoveResponse>> {
            const localVarAxiosArgs = await AssessmentApiAxiosParamCreator(configuration).apiAssessmentValidateMovePost(body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * AssessmentApi - factory interface
 * @export
 */
export const AssessmentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Provides a list of assessment periods
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentAssessmentPeriodsGet(options?: any): AxiosPromise<AssessmentAssessmentPeriodsResponse> {
            return AssessmentApiFp(configuration).apiAssessmentAssessmentPeriodsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Provides a list of available assessments
         * @param {string} [studentId] 
         * @param {AssessmentType} [assessmentType] Assessment type.
         * @param {string} [assessmentPeriodId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentAssessmentsGet(studentId?: string, assessmentType?: AssessmentType, assessmentPeriodId?: string, options?: any): AxiosPromise<AssessmentAssessmentsResponse> {
            return AssessmentApiFp(configuration).apiAssessmentAssessmentsGet(studentId, assessmentType, assessmentPeriodId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Provides a list of classes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentClassesGet(options?: any): AxiosPromise<AssessmentClassesResponse> {
            return AssessmentApiFp(configuration).apiAssessmentClassesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates an initial assessment record
         * @param {AssessmentCreateCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentCreatePost(body?: AssessmentCreateCommand, options?: any): AxiosPromise<AssessmentCreateResponse> {
            return AssessmentApiFp(configuration).apiAssessmentCreatePost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Provides an overview of student's benchmarks
         * @param {string} [_class] 
         * @param {string} [assessmentPeriodId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentDashboardGet(_class?: string, assessmentPeriodId?: string, options?: any): AxiosPromise<AssessmentDashboardResponse> {
            return AssessmentApiFp(configuration).apiAssessmentDashboardGet(_class, assessmentPeriodId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Provides a detailed Llars assessment
         * @param {string} [recordId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentEditLlarsGet(recordId?: string, options?: any): AxiosPromise<AssessmentEditLlarsResponse> {
            return AssessmentApiFp(configuration).apiAssessmentEditLlarsGet(recordId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edits a Llars assessment
         * @param {AssessmentEditLlarsCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentEditLlarsPost(body?: AssessmentEditLlarsCommand, options?: any): AxiosPromise<SharedModelsCommandResponse> {
            return AssessmentApiFp(configuration).apiAssessmentEditLlarsPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Provides a detailed Llass assessment
         * @param {string} [recordId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentEditLlassGet(recordId?: string, options?: any): AxiosPromise<AssessmentEditLlassResponse> {
            return AssessmentApiFp(configuration).apiAssessmentEditLlassGet(recordId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edits a Llass assessment
         * @param {AssessmentEditLlassCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentEditLlassPost(body?: AssessmentEditLlassCommand, options?: any): AxiosPromise<SharedModelsCommandResponse> {
            return AssessmentApiFp(configuration).apiAssessmentEditLlassPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Downloads an excel export of student results
         * @param {AssessmentExportListCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentExportListPost(body?: AssessmentExportListCommand, options?: any): AxiosPromise<AssessmentExportListResponse> {
            return AssessmentApiFp(configuration).apiAssessmentExportListPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Provides a list of classes and info for importing historical data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentImportListGet(options?: any): AxiosPromise<AssessmentImportListResponse> {
            return AssessmentApiFp(configuration).apiAssessmentImportListGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Imports historical data for a list of students
         * @param {AssessmentImportCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentImportPost(body?: AssessmentImportCommand, options?: any): AxiosPromise<SharedModelsCommandResponse> {
            return AssessmentApiFp(configuration).apiAssessmentImportPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Provides a list of data for moving assessment records
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentMoveListGet(options?: any): AxiosPromise<AssessmentMoveListResponse> {
            return AssessmentApiFp(configuration).apiAssessmentMoveListGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Moves assessment records to a different assessment period
         * @param {AssessmentMoveCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentMovePost(body?: AssessmentMoveCommand, options?: any): AxiosPromise<SharedModelsCommandResponse> {
            return AssessmentApiFp(configuration).apiAssessmentMovePost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Provides a list of assessment resources to download
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentResourceListGet(options?: any): AxiosPromise<AssessmentResourceListResponse> {
            return AssessmentApiFp(configuration).apiAssessmentResourceListGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Provides a list of students and their assessment record ids. Used for navigating between students while conducting assessments
         * @param {string} [studentId] 
         * @param {string} [classId] 
         * @param {string} [assessmentId] 
         * @param {string} [assessmentPeriodId] 
         * @param {AssessmentSubType} [assessmentType] Assessment sub type.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentStudentNavigationListGet(studentId?: string, classId?: string, assessmentId?: string, assessmentPeriodId?: string, assessmentType?: AssessmentSubType, options?: any): AxiosPromise<AssessmentStudentNavigationListResponse> {
            return AssessmentApiFp(configuration).apiAssessmentStudentNavigationListGet(studentId, classId, assessmentId, assessmentPeriodId, assessmentType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Provides a list of students for the provided class id or search term
         * @param {string} [classId] 
         * @param {string} [searchTerm] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentStudentSearchGet(classId?: string, searchTerm?: string, options?: any): AxiosPromise<AssessmentStudentSearchResponse> {
            return AssessmentApiFp(configuration).apiAssessmentStudentSearchGet(classId, searchTerm, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Provides a list of student stage mastery for an assessment period
         * @param {AssessmentStudentStageMasteryCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentStudentStageMasteryPost(body?: AssessmentStudentStageMasteryCommand, options?: any): AxiosPromise<AssessmentStudentStageMasteryResponse> {
            return AssessmentApiFp(configuration).apiAssessmentStudentStageMasteryPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Provides a list of students for a certain class
         * @param {string} [classId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentStudentsGet(classId?: string, options?: any): AxiosPromise<AssessmentStudentsResponse> {
            return AssessmentApiFp(configuration).apiAssessmentStudentsGet(classId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Provides an overview of student's assessment results for LLARS Subtest One - Grapheme-phoneme Knowledge
         * @param {string} [_class] 
         * @param {string} [assessmentPeriodId] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {AssessmentSummaryGraphemePhonemeQuerySortTypeFilter} [sortType] 
         * @param {AssessmentSummaryGraphemePhonemeQuerySortOrderType} [sortOrder] 
         * @param {string} [sortLetter] 
         * @param {string} [sortStageId] 
         * @param {AssessmentBenchmarkLevel} [benchmark] Assessment benchmark level.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentSummaryGraphemePhonemeGet(_class?: string, assessmentPeriodId?: string, pageNumber?: number, pageSize?: number, sortType?: AssessmentSummaryGraphemePhonemeQuerySortTypeFilter, sortOrder?: AssessmentSummaryGraphemePhonemeQuerySortOrderType, sortLetter?: string, sortStageId?: string, benchmark?: AssessmentBenchmarkLevel, options?: any): AxiosPromise<AssessmentSummaryGraphemePhonemeResponse> {
            return AssessmentApiFp(configuration).apiAssessmentSummaryGraphemePhonemeGet(_class, assessmentPeriodId, pageNumber, pageSize, sortType, sortOrder, sortLetter, sortStageId, benchmark, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Provides a list of filters used on the Student Results page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentSummaryListGet(options?: any): AxiosPromise<AssessmentSummaryListResponse> {
            return AssessmentApiFp(configuration).apiAssessmentSummaryListGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Provides an overview of student's assessment results
         * @param {string} [_class] 
         * @param {string} [assessmentPeriodId] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {AssessmentSummaryOverviewQuerySortTypeFilter} [sortType] 
         * @param {AssessmentSummaryOverviewQuerySortOrderType} [sortOrder] 
         * @param {string} [sortStageId] 
         * @param {AssessmentBenchmarkLevel} [benchmark] Assessment benchmark level.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentSummaryOverviewGet(_class?: string, assessmentPeriodId?: string, pageNumber?: number, pageSize?: number, sortType?: AssessmentSummaryOverviewQuerySortTypeFilter, sortOrder?: AssessmentSummaryOverviewQuerySortOrderType, sortStageId?: string, benchmark?: AssessmentBenchmarkLevel, options?: any): AxiosPromise<AssessmentSummaryOverviewResponse> {
            return AssessmentApiFp(configuration).apiAssessmentSummaryOverviewGet(_class, assessmentPeriodId, pageNumber, pageSize, sortType, sortOrder, sortStageId, benchmark, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Provides an overview of student's assessment progress across assessment periods
         * @param {string} [_class] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {AssessmentSummaryProgressQuerySortTypeFilter} [sortType] 
         * @param {AssessmentSummaryProgressQuerySortOrderType} [sortOrder] 
         * @param {string} [sortAssessmentPeriodId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentSummaryProgressGet(_class?: string, pageNumber?: number, pageSize?: number, sortType?: AssessmentSummaryProgressQuerySortTypeFilter, sortOrder?: AssessmentSummaryProgressQuerySortOrderType, sortAssessmentPeriodId?: string, options?: any): AxiosPromise<AssessmentSummaryProgressResponse> {
            return AssessmentApiFp(configuration).apiAssessmentSummaryProgressGet(_class, pageNumber, pageSize, sortType, sortOrder, sortAssessmentPeriodId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Provides an overview of student's assessment results for LLARS Subtest Two - Reading non-words
         * @param {string} [_class] 
         * @param {string} [assessmentPeriodId] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {AssessmentSummaryReadingQuerySortTypeFilter} [sortType] 
         * @param {AssessmentSummaryReadingQuerySortOrderType} [sortOrder] 
         * @param {string} [sortText] 
         * @param {string} [sortStageId] 
         * @param {AssessmentBenchmarkLevel} [benchmark] Assessment benchmark level.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentSummaryReadingGet(_class?: string, assessmentPeriodId?: string, pageNumber?: number, pageSize?: number, sortType?: AssessmentSummaryReadingQuerySortTypeFilter, sortOrder?: AssessmentSummaryReadingQuerySortOrderType, sortText?: string, sortStageId?: string, benchmark?: AssessmentBenchmarkLevel, options?: any): AxiosPromise<AssessmentSummaryReadingResponse> {
            return AssessmentApiFp(configuration).apiAssessmentSummaryReadingGet(_class, assessmentPeriodId, pageNumber, pageSize, sortType, sortOrder, sortText, sortStageId, benchmark, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Provides an overview of student's assessment results for LLARS Subtest Three - Spelling
         * @param {string} [_class] 
         * @param {string} [assessmentPeriodId] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {AssessmentSummarySpellingQuerySortTypeFilter} [sortType] 
         * @param {AssessmentSummarySpellingQuerySortOrderType} [sortOrder] 
         * @param {string} [sortLetter] 
         * @param {string} [sortStageId] 
         * @param {AssessmentBenchmarkLevel} [benchmark] Assessment benchmark level.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentSummarySpellingGet(_class?: string, assessmentPeriodId?: string, pageNumber?: number, pageSize?: number, sortType?: AssessmentSummarySpellingQuerySortTypeFilter, sortOrder?: AssessmentSummarySpellingQuerySortOrderType, sortLetter?: string, sortStageId?: string, benchmark?: AssessmentBenchmarkLevel, options?: any): AxiosPromise<AssessmentSummarySpellingResponse> {
            return AssessmentApiFp(configuration).apiAssessmentSummarySpellingGet(_class, assessmentPeriodId, pageNumber, pageSize, sortType, sortOrder, sortLetter, sortStageId, benchmark, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Provides an overview of student's assessment results by stage
         * @param {string} [_class] 
         * @param {string} [assessmentPeriodId] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {AssessmentSummaryStageOverviewQuerySortTypeFilter} [sortType] 
         * @param {AssessmentSummaryStageOverviewQuerySortOrderType} [sortOrder] 
         * @param {AssessmentBenchmarkLevel} [benchmark] Assessment benchmark level.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentSummaryStageOverviewGet(_class?: string, assessmentPeriodId?: string, pageNumber?: number, pageSize?: number, sortType?: AssessmentSummaryStageOverviewQuerySortTypeFilter, sortOrder?: AssessmentSummaryStageOverviewQuerySortOrderType, benchmark?: AssessmentBenchmarkLevel, options?: any): AxiosPromise<AssessmentSummaryStageOverviewResponse> {
            return AssessmentApiFp(configuration).apiAssessmentSummaryStageOverviewGet(_class, assessmentPeriodId, pageNumber, pageSize, sortType, sortOrder, benchmark, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Validates data for moving assessment records
         * @param {AssessmentValidateMoveCommand} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAssessmentValidateMovePost(body?: AssessmentValidateMoveCommand, options?: any): AxiosPromise<AssessmentValidateMoveResponse> {
            return AssessmentApiFp(configuration).apiAssessmentValidateMovePost(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AssessmentApi - object-oriented interface
 * @export
 * @class AssessmentApi
 * @extends {BaseAPI}
 */
export class AssessmentApi extends BaseAPI {
    /**
     * 
     * @summary Provides a list of assessment periods
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentApi
     */
    public apiAssessmentAssessmentPeriodsGet(options?: any) {
        return AssessmentApiFp(this.configuration).apiAssessmentAssessmentPeriodsGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Provides a list of available assessments
     * @param {string} [studentId] 
     * @param {AssessmentType} [assessmentType] Assessment type.
     * @param {string} [assessmentPeriodId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentApi
     */
    public apiAssessmentAssessmentsGet(studentId?: string, assessmentType?: AssessmentType, assessmentPeriodId?: string, options?: any) {
        return AssessmentApiFp(this.configuration).apiAssessmentAssessmentsGet(studentId, assessmentType, assessmentPeriodId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Provides a list of classes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentApi
     */
    public apiAssessmentClassesGet(options?: any) {
        return AssessmentApiFp(this.configuration).apiAssessmentClassesGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Creates an initial assessment record
     * @param {AssessmentCreateCommand} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentApi
     */
    public apiAssessmentCreatePost(body?: AssessmentCreateCommand, options?: any) {
        return AssessmentApiFp(this.configuration).apiAssessmentCreatePost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Provides an overview of student's benchmarks
     * @param {string} [_class] 
     * @param {string} [assessmentPeriodId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentApi
     */
    public apiAssessmentDashboardGet(_class?: string, assessmentPeriodId?: string, options?: any) {
        return AssessmentApiFp(this.configuration).apiAssessmentDashboardGet(_class, assessmentPeriodId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Provides a detailed Llars assessment
     * @param {string} [recordId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentApi
     */
    public apiAssessmentEditLlarsGet(recordId?: string, options?: any) {
        return AssessmentApiFp(this.configuration).apiAssessmentEditLlarsGet(recordId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Edits a Llars assessment
     * @param {AssessmentEditLlarsCommand} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentApi
     */
    public apiAssessmentEditLlarsPost(body?: AssessmentEditLlarsCommand, options?: any) {
        return AssessmentApiFp(this.configuration).apiAssessmentEditLlarsPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Provides a detailed Llass assessment
     * @param {string} [recordId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentApi
     */
    public apiAssessmentEditLlassGet(recordId?: string, options?: any) {
        return AssessmentApiFp(this.configuration).apiAssessmentEditLlassGet(recordId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Edits a Llass assessment
     * @param {AssessmentEditLlassCommand} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentApi
     */
    public apiAssessmentEditLlassPost(body?: AssessmentEditLlassCommand, options?: any) {
        return AssessmentApiFp(this.configuration).apiAssessmentEditLlassPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Downloads an excel export of student results
     * @param {AssessmentExportListCommand} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentApi
     */
    public apiAssessmentExportListPost(body?: AssessmentExportListCommand, options?: any) {
        return AssessmentApiFp(this.configuration).apiAssessmentExportListPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Provides a list of classes and info for importing historical data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentApi
     */
    public apiAssessmentImportListGet(options?: any) {
        return AssessmentApiFp(this.configuration).apiAssessmentImportListGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Imports historical data for a list of students
     * @param {AssessmentImportCommand} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentApi
     */
    public apiAssessmentImportPost(body?: AssessmentImportCommand, options?: any) {
        return AssessmentApiFp(this.configuration).apiAssessmentImportPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Provides a list of data for moving assessment records
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentApi
     */
    public apiAssessmentMoveListGet(options?: any) {
        return AssessmentApiFp(this.configuration).apiAssessmentMoveListGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Moves assessment records to a different assessment period
     * @param {AssessmentMoveCommand} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentApi
     */
    public apiAssessmentMovePost(body?: AssessmentMoveCommand, options?: any) {
        return AssessmentApiFp(this.configuration).apiAssessmentMovePost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Provides a list of assessment resources to download
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentApi
     */
    public apiAssessmentResourceListGet(options?: any) {
        return AssessmentApiFp(this.configuration).apiAssessmentResourceListGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Provides a list of students and their assessment record ids. Used for navigating between students while conducting assessments
     * @param {string} [studentId] 
     * @param {string} [classId] 
     * @param {string} [assessmentId] 
     * @param {string} [assessmentPeriodId] 
     * @param {AssessmentSubType} [assessmentType] Assessment sub type.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentApi
     */
    public apiAssessmentStudentNavigationListGet(studentId?: string, classId?: string, assessmentId?: string, assessmentPeriodId?: string, assessmentType?: AssessmentSubType, options?: any) {
        return AssessmentApiFp(this.configuration).apiAssessmentStudentNavigationListGet(studentId, classId, assessmentId, assessmentPeriodId, assessmentType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Provides a list of students for the provided class id or search term
     * @param {string} [classId] 
     * @param {string} [searchTerm] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentApi
     */
    public apiAssessmentStudentSearchGet(classId?: string, searchTerm?: string, options?: any) {
        return AssessmentApiFp(this.configuration).apiAssessmentStudentSearchGet(classId, searchTerm, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Provides a list of student stage mastery for an assessment period
     * @param {AssessmentStudentStageMasteryCommand} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentApi
     */
    public apiAssessmentStudentStageMasteryPost(body?: AssessmentStudentStageMasteryCommand, options?: any) {
        return AssessmentApiFp(this.configuration).apiAssessmentStudentStageMasteryPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Provides a list of students for a certain class
     * @param {string} [classId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentApi
     */
    public apiAssessmentStudentsGet(classId?: string, options?: any) {
        return AssessmentApiFp(this.configuration).apiAssessmentStudentsGet(classId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Provides an overview of student's assessment results for LLARS Subtest One - Grapheme-phoneme Knowledge
     * @param {string} [_class] 
     * @param {string} [assessmentPeriodId] 
     * @param {number} [pageNumber] 
     * @param {number} [pageSize] 
     * @param {AssessmentSummaryGraphemePhonemeQuerySortTypeFilter} [sortType] 
     * @param {AssessmentSummaryGraphemePhonemeQuerySortOrderType} [sortOrder] 
     * @param {string} [sortLetter] 
     * @param {string} [sortStageId] 
     * @param {AssessmentBenchmarkLevel} [benchmark] Assessment benchmark level.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentApi
     */
    public apiAssessmentSummaryGraphemePhonemeGet(_class?: string, assessmentPeriodId?: string, pageNumber?: number, pageSize?: number, sortType?: AssessmentSummaryGraphemePhonemeQuerySortTypeFilter, sortOrder?: AssessmentSummaryGraphemePhonemeQuerySortOrderType, sortLetter?: string, sortStageId?: string, benchmark?: AssessmentBenchmarkLevel, options?: any) {
        return AssessmentApiFp(this.configuration).apiAssessmentSummaryGraphemePhonemeGet(_class, assessmentPeriodId, pageNumber, pageSize, sortType, sortOrder, sortLetter, sortStageId, benchmark, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Provides a list of filters used on the Student Results page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentApi
     */
    public apiAssessmentSummaryListGet(options?: any) {
        return AssessmentApiFp(this.configuration).apiAssessmentSummaryListGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Provides an overview of student's assessment results
     * @param {string} [_class] 
     * @param {string} [assessmentPeriodId] 
     * @param {number} [pageNumber] 
     * @param {number} [pageSize] 
     * @param {AssessmentSummaryOverviewQuerySortTypeFilter} [sortType] 
     * @param {AssessmentSummaryOverviewQuerySortOrderType} [sortOrder] 
     * @param {string} [sortStageId] 
     * @param {AssessmentBenchmarkLevel} [benchmark] Assessment benchmark level.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentApi
     */
    public apiAssessmentSummaryOverviewGet(_class?: string, assessmentPeriodId?: string, pageNumber?: number, pageSize?: number, sortType?: AssessmentSummaryOverviewQuerySortTypeFilter, sortOrder?: AssessmentSummaryOverviewQuerySortOrderType, sortStageId?: string, benchmark?: AssessmentBenchmarkLevel, options?: any) {
        return AssessmentApiFp(this.configuration).apiAssessmentSummaryOverviewGet(_class, assessmentPeriodId, pageNumber, pageSize, sortType, sortOrder, sortStageId, benchmark, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Provides an overview of student's assessment progress across assessment periods
     * @param {string} [_class] 
     * @param {number} [pageNumber] 
     * @param {number} [pageSize] 
     * @param {AssessmentSummaryProgressQuerySortTypeFilter} [sortType] 
     * @param {AssessmentSummaryProgressQuerySortOrderType} [sortOrder] 
     * @param {string} [sortAssessmentPeriodId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentApi
     */
    public apiAssessmentSummaryProgressGet(_class?: string, pageNumber?: number, pageSize?: number, sortType?: AssessmentSummaryProgressQuerySortTypeFilter, sortOrder?: AssessmentSummaryProgressQuerySortOrderType, sortAssessmentPeriodId?: string, options?: any) {
        return AssessmentApiFp(this.configuration).apiAssessmentSummaryProgressGet(_class, pageNumber, pageSize, sortType, sortOrder, sortAssessmentPeriodId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Provides an overview of student's assessment results for LLARS Subtest Two - Reading non-words
     * @param {string} [_class] 
     * @param {string} [assessmentPeriodId] 
     * @param {number} [pageNumber] 
     * @param {number} [pageSize] 
     * @param {AssessmentSummaryReadingQuerySortTypeFilter} [sortType] 
     * @param {AssessmentSummaryReadingQuerySortOrderType} [sortOrder] 
     * @param {string} [sortText] 
     * @param {string} [sortStageId] 
     * @param {AssessmentBenchmarkLevel} [benchmark] Assessment benchmark level.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentApi
     */
    public apiAssessmentSummaryReadingGet(_class?: string, assessmentPeriodId?: string, pageNumber?: number, pageSize?: number, sortType?: AssessmentSummaryReadingQuerySortTypeFilter, sortOrder?: AssessmentSummaryReadingQuerySortOrderType, sortText?: string, sortStageId?: string, benchmark?: AssessmentBenchmarkLevel, options?: any) {
        return AssessmentApiFp(this.configuration).apiAssessmentSummaryReadingGet(_class, assessmentPeriodId, pageNumber, pageSize, sortType, sortOrder, sortText, sortStageId, benchmark, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Provides an overview of student's assessment results for LLARS Subtest Three - Spelling
     * @param {string} [_class] 
     * @param {string} [assessmentPeriodId] 
     * @param {number} [pageNumber] 
     * @param {number} [pageSize] 
     * @param {AssessmentSummarySpellingQuerySortTypeFilter} [sortType] 
     * @param {AssessmentSummarySpellingQuerySortOrderType} [sortOrder] 
     * @param {string} [sortLetter] 
     * @param {string} [sortStageId] 
     * @param {AssessmentBenchmarkLevel} [benchmark] Assessment benchmark level.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentApi
     */
    public apiAssessmentSummarySpellingGet(_class?: string, assessmentPeriodId?: string, pageNumber?: number, pageSize?: number, sortType?: AssessmentSummarySpellingQuerySortTypeFilter, sortOrder?: AssessmentSummarySpellingQuerySortOrderType, sortLetter?: string, sortStageId?: string, benchmark?: AssessmentBenchmarkLevel, options?: any) {
        return AssessmentApiFp(this.configuration).apiAssessmentSummarySpellingGet(_class, assessmentPeriodId, pageNumber, pageSize, sortType, sortOrder, sortLetter, sortStageId, benchmark, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Provides an overview of student's assessment results by stage
     * @param {string} [_class] 
     * @param {string} [assessmentPeriodId] 
     * @param {number} [pageNumber] 
     * @param {number} [pageSize] 
     * @param {AssessmentSummaryStageOverviewQuerySortTypeFilter} [sortType] 
     * @param {AssessmentSummaryStageOverviewQuerySortOrderType} [sortOrder] 
     * @param {AssessmentBenchmarkLevel} [benchmark] Assessment benchmark level.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentApi
     */
    public apiAssessmentSummaryStageOverviewGet(_class?: string, assessmentPeriodId?: string, pageNumber?: number, pageSize?: number, sortType?: AssessmentSummaryStageOverviewQuerySortTypeFilter, sortOrder?: AssessmentSummaryStageOverviewQuerySortOrderType, benchmark?: AssessmentBenchmarkLevel, options?: any) {
        return AssessmentApiFp(this.configuration).apiAssessmentSummaryStageOverviewGet(_class, assessmentPeriodId, pageNumber, pageSize, sortType, sortOrder, benchmark, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @summary Validates data for moving assessment records
     * @param {AssessmentValidateMoveCommand} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssessmentApi
     */
    public apiAssessmentValidateMovePost(body?: AssessmentValidateMoveCommand, options?: any) {
        return AssessmentApiFp(this.configuration).apiAssessmentValidateMovePost(body, options).then((request) => request(this.axios, this.basePath));
    }
}
